import React, {useEffect, useState} from "react";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_BUTTON_ACTION_GROUND_PLAYER_DATA_API} from "../../constants/api_constants";
import {ModalHandler} from "../Modal/Generic/ModalHandler";


const ScoreTableCard = ({homeTeamData, awayTeamData, dataId, setPlayerDataDetails, refreshDate, buttonValue}) => {
  // <-- 상단 테이블 -->
  const [scoreTableList, setScoreTableList] = useState([
    {name: "평점", home: null, away: null},
    {name: "평균슈팅", home: null, away: null},
    {name: "점유율", home: null, away: null},
    {name: "패스성공율", home: null, away: null},
    {name: "평균드리블", home: null, away: null},
    {name: "공중볼", home: null, away: null},
    {name: "태클", home: null, away: null},
    {name: "코너킥", home: null, away: null},
    {name: "실책", home: null, away: null},
  ]);

  // <-- 하단 테이블 -->
  const [pointAverageTable, setPointAverageTable] = useState([
    {name: "평점", home: null, away: null},
  ]);
  const [shootingTable, setShootingTable] = useState([
    {name: "평균슈팅", home: null, away: null},
    {name: "골대", home: null, away: null},
    {name: "유효슈팅", home: null, away: null},
    {name: "빗나간슈팅", home: null, away: null},
    {name: "막힌슈팅", home: null, away: null},
  ]);
  const [shareTable, setShareTable] = useState([
    {name: "점유율", home: null, away: null},
    {name: "터치수", home: null, away: null},
  ]);
  const [passTable, setPassTable] = useState([
    {name: "패스 성공율", home: null, away: null},
    {name: "총패스횟수", home: null, away: null},
    {name: "정확한패스", home: null, away: null},
    {name: "키패스", home: null, away: null},
  ]);
  const [dribbleTable, setDribbleTable] = useState([
    {name: "평균드리블", home: null, away: null},
    {name: "드리블시도", home: null, away: null},
    {name: "드리블실패", home: null, away: null},
    {name: "드리블성공률", home: null, away: null},
  ]);
  const [aerialTable, setAerialTable] = useState([
    {name: "공중볼", home: null, away: null},
    {name: "공중볼성공율", home: null, away: null},
    {name: "공중볼(공격)", home: null, away: null},
    {name: "공중볼(방어)", home: null, away: null},
  ]);
  const [tackleTable, setTackleTable] = useState([
    {name: "태클", home: null, away: null},
    {name: "태클시도", home: null, away: null},
    {name: "태클실패", home: null, away: null},
    {name: "태클성공률", home: null, away: null},
    {name: "걷어낸횟수", home: null, away: null},
    {name: "가로채기", home: null, away: null},
  ]);
  const [cornerTable, setCornerTable] = useState([
    {name: "코너킥", home: null, away: null},
    {name: "코너킥정확도", home: null, away: null},
  ]);
  const [dispossessedTable, setDispossessedTable] = useState([
    {name: "실책", home: null, away: null},
    {name: "에러", home: null, away: null},
    {name: "파울", home: null, away: null},
    {name: "오프사이드", home: null, away: null},
  ]);

  const [scoreTableButtonValue, setScoreTableButtonValue] = useState("-");
  const [subTableList, setSubTableList] = useState([]); // 아래에 띄울 테이블
  const [subTableButtonValue, setSubTableButtonValue] = useState(pointAverageTable[0].name);
  const [option1, setOption1] = useState(1); // 상단 선택 옵션값
  const [option2, setOption2] = useState(1); // 하단 선택 옵션값

  const [redrawDate, setRedrawDate] = useState(0);

  useEffect(() => {
    if (!homeTeamData || !awayTeamData) return;
    if (!homeTeamData.RATE || !awayTeamData.RATE) return;

    const updatedTableList = [
      {name: "평점", home: homeTeamData.RATE, away: awayTeamData.RATE},
      {name: "슈팅 평균", home: homeTeamData.SHOTS, away: awayTeamData.SHOTS},
      {name: "점유율", home: homeTeamData.POSSESSION, away: awayTeamData.POSSESSION},
      {name: "패스 성공율", home: homeTeamData.PASS_SUC, away: awayTeamData.PASS_SUC},
      {name: "드리블 평균", home: homeTeamData.DRIBBLES, away: awayTeamData.DRIBBLES},
      {name: "공중볼", home: homeTeamData.AERIALS_WON, away: awayTeamData.AERIALS_WON},
      {name: "태클", home: homeTeamData.TACKLES, away: awayTeamData.TACKLES},
      {name: "코너킥", home: homeTeamData.CORNERS, away: awayTeamData.CORNERS},
      {name: "실책", home: homeTeamData.DISPOSSESSED, away: awayTeamData.DISPOSSESSED},
    ];

    const updatedPointAverageTableList = [
      {name: "평점", home: homeTeamData.RATE, away: awayTeamData.RATE},
    ];

    if (scoreTableButtonValue === '-') {
      setScoreTableButtonValue("평점");
    }
    setPointAverageTable(updatedPointAverageTableList);
    setScoreTableList(updatedTableList);

    const updatedShootingTableList = [
      {name: "슈팅 평균", home: homeTeamData.SHOTS, away: awayTeamData.SHOTS},
      {name: "골대", home: homeTeamData.WOODWORK, away: awayTeamData.WOODWORK},
      {name: "유효슈팅", home: homeTeamData.SHOTS_ON_TARGET, away: awayTeamData.SHOTS_ON_TARGET},
      {name: "빗나간슈팅", home: homeTeamData.SHOTS_OFF_TARGET, away: awayTeamData.SHOTS_OFF_TARGET},
      {name: "막힌슈팅", home: homeTeamData.SHOTS_BLOCK, away: awayTeamData.SHOTS_BLOCK},
    ];
    setShootingTable(updatedShootingTableList);

    const updatedShareTableList = [
      {name: "점유율", home: homeTeamData.POSSESSION, away: awayTeamData.POSSESSION},
      {name: "터치수", home: homeTeamData.TOUCHES, away: awayTeamData.TOUCHES},
    ];
    setShareTable(updatedShareTableList);

    const updatedPassTableList = [
      {name: "패스 성공율", home: homeTeamData.PASS_SUC, away: awayTeamData.PASS_SUC},
      {name: "총패스횟수", home: homeTeamData.TOTAL_PASSES, away: awayTeamData.TOTAL_PASSES},
      {name: "정확한패스", home: homeTeamData.ACCURATE_PASSES, away: awayTeamData.ACCURATE_PASSES},
      {name: "키패스", home: homeTeamData.KEY_PASSES, away: awayTeamData.KEY_PASSES},
    ];
    setPassTable(updatedPassTableList);

    const updatedDribbleTableList = [
      {name: "드리블 평균", home: homeTeamData.DRIBBLES, away: awayTeamData.DRIBBLES},
      {name: "드리블시도", home: homeTeamData.DRIBBLES_ATTEMPTED, away: awayTeamData.DRIBBLES_ATTEMPTED},
      {name: "드리블실패", home: homeTeamData.DRIBBLES_PAST, away: awayTeamData.DRIBBLES_PAST},
      {name: "드리블성공률", home: homeTeamData.DRIBBLES_SUC, away: awayTeamData.DRIBBLES_SUC},
    ];
    setDribbleTable(updatedDribbleTableList);

    const updatedAerialTableList = [
      {name: "공중볼", home: homeTeamData.AERIALS_WON, away: awayTeamData.AERIALS_WON},
      {name: "공중볼성공율", home: homeTeamData.AERIALS_WON_PER, away: awayTeamData.AERIALS_WON_PER},
      {name: "공중볼(공격)", home: homeTeamData.OFFENSIVE_AERIALS, away: awayTeamData.OFFENSIVE_AERIALS},
      {name: "공중볼(방어)", home: homeTeamData.DEFENSIVE_AERIALS, away: awayTeamData.DEFENSIVE_AERIALS},
    ];
    setAerialTable(updatedAerialTableList);

    const updatedTackleTableList = [
      {name: "태클", home: homeTeamData.AERIALS_WON, away: awayTeamData.AERIALS_WON},
      {name: "태클시도", home: homeTeamData.TACKLE_ATEMPTED, away: awayTeamData.TACKLE_ATEMPTED},
      {name: "태클실패", home: homeTeamData.WAS_DRIBBLED, away: awayTeamData.WAS_DRIBBLED},
      {name: "태클성공률", home: homeTeamData.TACKLE_SUC, away: awayTeamData.TACKLE_SUC},
      {name: "걷어낸횟수", home: homeTeamData.CLEARANCES, away: awayTeamData.CLEARANCES},
      {name: "가로채기", home: homeTeamData.INTERCEPTIONS, away: awayTeamData.INTERCEPTIONS},
    ];
    setTackleTable(updatedTackleTableList);

    const updatedCornerTableList = [
      {name: "코너킥", home: homeTeamData.CORNERS, away: awayTeamData.CORNERS},
      {name: "코너킥정확도", home: homeTeamData.CORNER_ACCURACY, away: awayTeamData.CORNER_ACCURACY},
    ];
    setCornerTable(updatedCornerTableList);

    const updatedDispossessedTableList = [
      {name: "실책", home: homeTeamData.DISPOSSESSED, away: awayTeamData.DISPOSSESSED},
      {name: "에러", home: homeTeamData.ERRORS, away: awayTeamData.ERRORS},
      {name: "파울", home: homeTeamData.FOULS, away: awayTeamData.FOULS},
      {name: "오프사이드", home: homeTeamData.OFFSIDES, away: awayTeamData.OFFSIDES},
    ];
    setDispossessedTable(updatedDispossessedTableList);

  }, [homeTeamData, awayTeamData]);

  useEffect(() => {
    // 전체평균 / 최근3경기 / 홈원정 버튼 누를때마다 옵션 1/1로 초기화
    setOption1(1);
    setOption2(1);
    setScoreTableButtonValue('평점');
  }, [buttonValue]);

  useEffect(() => {
    // 상단 버튼 바뀔때마다 하단 버튼 초기값 지정
    if (subTableList && subTableList.length > 0)
      setSubTableButtonValue(subTableList[0]?.name);
  }, [subTableList]);

  function updateScoreTableUpdate() {
    // 상단 버튼 바뀔때마다 하단 버튼 리스트 지정
    if (scoreTableButtonValue === "평점") setSubTableList(pointAverageTable);
    if (scoreTableButtonValue === "슈팅 평균") setSubTableList(shootingTable);
    if (scoreTableButtonValue === "점유율") setSubTableList(shareTable);
    if (scoreTableButtonValue === "패스 성공율") setSubTableList(passTable);
    if (scoreTableButtonValue === "드리블 평균") setSubTableList(dribbleTable);
    if (scoreTableButtonValue === "공중볼") setSubTableList(aerialTable);
    if (scoreTableButtonValue === "태클") setSubTableList(tackleTable);
    if (scoreTableButtonValue === "코너킥") setSubTableList(cornerTable);
    if (scoreTableButtonValue === "실책") setSubTableList(dispossessedTable);
  }

  useEffect(() => {
    updateScoreTableUpdate();
  }, [scoreTableButtonValue]);

  useEffect(() => {
    updatePlayerRates();
  }, [option1, option2, refreshDate]);

  const updatePlayerRates = () => {
    getFetcherAnalysis().get(GET_BUTTON_ACTION_GROUND_PLAYER_DATA_API + `?dataId=${dataId}&opt1=${option1}&opt2=${option2}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            setPlayerDataDetails({
              list: data,
              updateDate: new Date(),
              option1: option1,
              option2: option2
            });
          } else {
            ModalHandler.openWarningModal("실패", responseResultDescription);
          }
        }).catch(err => console.log(err));
  }

  return (
      <div className="w-full flex flex-col mt-5">
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="text-2xl">평균 평점</p>
          <button
              className={neverLandUtils.classNames(scoreTableButtonValue === '출전횟수' ? "bg-teal-500 text-white" : "bg-teal-50 text-teal-700", "ring ring-teal-600 px-2 rounded-lg mr-2")}
              onClick={() => {
                setScoreTableButtonValue('출전횟수');
                setSubTableButtonValue(null);
                setOption1('count');
                setOption2('playing');
              }}
          >
            출전횟수
          </button>
        </div>

        <div className="w-full border-t-2 border-gray-900 mt-1"/>

        <div className="text-sm">
          {/* <-- 상단 영역 --> */}
          <div
              className="flex flex-row py-2 overflow-scroll [&::-webkit-scrollbar]:hidden lg:overflow-visible lg:flex-wrap"
              style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
          >
            {scoreTableList?.map((data, index) => {
              return (
                  <div
                      className="flex flex-col border border-gray-400 shadow-lg whitespace-nowrap mr-2 box-border cursor-pointer rounded-lg mt-1"
                      key={index}
                      onClick={() => {
                        setScoreTableButtonValue(data.name);
                        setOption1(index + 1);
                        setOption2(1);
                      }}
                  >
                    <p className={neverLandUtils.classNames(scoreTableButtonValue === data.name ? "bg-slate-800 text-white" : "", "text-center p-1 rounded-t-lg")}>
                      {data.name}
                    </p>

                    <div className="flex flex-row border-t border-gray-400">
                      <div
                          className={`w-1/2 text-center border-r border-gray-400 px-2 pt-1 pb-0.5 ${parseFloat(data.home) > parseFloat(data.away) ? 'text-red-500' : ''}`}>
                        <p>{data.home}</p>
                      </div>
                      <div
                          className={`w-1/2 text-center px-2 pt-1 pb-0.5 ${parseFloat(data.away) > parseFloat(data.home) ? 'text-red-500' : ''}`}>
                        <p>{data.away}</p>
                      </div>
                    </div>
                  </div>
              );
            })}
          </div>

          {/* <-- 클릭시 생기는 하단 영역 --> */}
          {subTableList && subTableList.length > 0 &&
              <div className="flex flex-row py-1.5 overflow-scroll [&::-webkit-scrollbar]:hidden"
                   style={{
                     scrollbarWidth: 'none',
                     msOverflowStyle: 'none',
                   }}
                   key={"subTableList_" + redrawDate}
              >
                {subTableList.map((data, index) => {
                  return (
                      <div
                          className="flex flex-col border border-gray-400 shadow-lg whitespace-nowrap mr-2 box-border cursor-pointer rounded-lg"
                          key={"subTableList_" + redrawDate + "_" + index}
                          onClick={() => {
                            setSubTableButtonValue(data.name);
                            setOption2(index + 1);
                          }}
                      >
                        <p className={neverLandUtils.classNames(subTableButtonValue === data.name ? "bg-slate-300" : "", "text-center p-1 rounded-t-lg")}>
                          {data.name}
                        </p>

                        <div className="flex flex-row border-t border-gray-400">
                          <div
                              className={`w-1/2 text-center border-r border-gray-400 px-2 pt-1 pb-0.5 ${parseFloat(data.home) > parseFloat(data.away) ? 'text-red-500' : ''}`}>
                            <p>{data.home ? data.home : "-"}</p>
                          </div>
                          <div
                              className={`w-1/2 text-center px-2 pt-1 pb-0.5 ${parseFloat(data.away) > parseFloat(data.home) ? 'text-red-500' : ''}`}>
                            <p>{data.away ? data.away : "-"}</p>
                          </div>
                        </div>
                      </div>
                  );
                })}
              </div>
          }
        </div>
      </div>
  )
}
export default ScoreTableCard;